import { AxiosResponse } from "axios";
import { peopleMentionBaseConfig } from "components/Quill/Mention/people/mentionConfig";
import { AutoCompleteDataModelDtoPaginatedList, DiscussionType, UserSelectionEntityType } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import { useRef } from "react";
import { NIL } from "uuid";
import { DiscussionBase } from "views/foundation/discussion/components/DiscussionBase";

export interface IDevPlanDiscussionProps {
    devPlanId: string;
    title?: string;
    readOnly?: boolean;
    initialValue?: string;

    onUpdateCommentCounter?: (totalComments: number) => void;
}

/**
 * Discussões de um plano de desenvolvimento
 * @param props
 */
export const DevPlanDiscussionBox: React.FC<IDevPlanDiscussionProps> = (props) => {

    const { devPlanId, title, readOnly, onUpdateCommentCounter } = props;
    const api = useCoreApi();
    const discussionType = useRef<DiscussionType>(DiscussionType.Public);

    function getMembers(searchText: string): Promise<AxiosResponse<AutoCompleteDataModelDtoPaginatedList>> {
        const inputValue = searchText.trim().toLowerCase();
        return api.v1.lmsDiscussion.devPlanUserDiscussionSuggestions({
            devPlanId,
            discussionType: discussionType.current,
            pageNumber: 1,
            pageSize: 10,
            searchText: inputValue,
            selectionHistoryType: UserSelectionEntityType.UserMention,
            ignoreSelectionHistory: false
        });
    }

    const configPeopleMention = {
        mention: {
            ...peopleMentionBaseConfig,
            source: function (searchTerm: any, renderList: any, mentionChar: any) {
                if (mentionChar === "@") {
                    getMembers(searchTerm)
                        .then((users) => {
                            var values = users.data.items.map((d) => ({ id: d.key, ot: "user", value: d.label }));
                            renderList(values, searchTerm);
                        })
                        .catch(() => {
                            renderList([], searchTerm);
                        });
                }
            }
        }
    };

    return (
        <DiscussionBase
            referenceId={devPlanId ?? NIL}
            title={title ?? ""}
            readOnly={readOnly}
            counterMode="none"
            configPeopleMention={configPeopleMention}
            initialValue={props.initialValue}
            onUpdateCommentCounter={onUpdateCommentCounter}
            onGetDiscussions={(parentId, startSequenceNum, take, filter, orderBy, discussionId) =>
                api.v1.lmsDiscussion.getDiscussionDevPlan({
                    parentId,
                    startSequenceNum,
                    take,
                    filter,
                    orderBy,
                    discussionId,
                    devPlanId,
                })
            }
            onPostNew={({ parentId, replyId, message, discussionType }) =>
                api.v1.lmsDiscussion.createDiscussionDevPlan({
                    devPlanId,
                    parentId,
                    replyId,
                    message,
                    discussionType
                })
            }
            onPostUpdate={(discussionId, message, discussionType) =>
                api.v1.lmsDiscussion.updateDiscussionDevPlan({ devPlanId, discussionId, message, discussionType })
            }
            onPostDelete={(discussionId) =>
                api.v1.lmsDiscussion.deleteDiscussionDevPlan({ devPlanId, discussionId })
            }
            onPostLike={(discussionId, like) =>
                api.v1.lmsDiscussion.likeDiscussionDevPlan({
                    devPlanId,
                    discussionId,
                    like
                })
            }
            onChangeDiscussionType={(value) => discussionType.current = value}
            onGetPeopleData={(p, signal) => api.v1.lmsDiscussion.devPlanUserDiscussionSelector({
                devPlanId: devPlanId,
                discussionType: discussionType.current,
                searchText: p.searchText,
                pageNumber: p.pageNumber,
                pageSize: p.pageSize,
                selectionHistoryType: UserSelectionEntityType.UserMention,
                ignoreSelectionHistory: p.ignoreSelectionHistory
            }, { signal })}
        />
    );
};
